var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMemberDetailInk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 964,
    viewBox: "0 0 17 964",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1103_28843)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.98552 568.289C6.43181 586.342 4.46166 599.926 5.97245 608.103C6.57174 592.702 6.68122 596.314 7.68038 581.114C7.43496 574.918 7.30826 568.044 5.98552 568.289Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21404 521.087C6.53599 515.471 10.1674 500.294 7.18781 501.962C7.49017 509.879 6.01612 527.789 8.21404 521.087Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.81864 458.32C8.24752 456.905 10.0954 436.275 7.86301 436.454C7.52365 445.696 7.31056 465.759 8.81864 458.32Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1603 409.682C16.9785 401.505 17.1383 387.444 15.2753 385.076C14.6062 395.323 14.4602 404.923 16.1603 409.682Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4978 376.928C16.8288 364.081 17.2652 351.071 15.754 346.84C15.6605 358.332 14.182 376.414 16.4978 376.928Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.21796 324.413C8.78214 326.588 7.9992 333.395 9.02756 332.785C8.71993 332.933 8.41231 333.082 8.4516 335.488C10.3057 338.199 9.22656 321.129 10.3869 319.327C9.53062 313.257 7.68886 317.926 7.21796 324.413Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8207 283.811L14.3367 283.923C14.1936 265.892 15.8001 242.843 14.1533 232.081C12.1302 247.72 13.1609 266.674 12.8207 283.811Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4095 201.993C14.117 202.045 14.7234 202.09 15.4309 202.142C15.7305 194.441 14.1924 195.186 13.6919 191.03C13.5992 194.627 13.5021 198.395 13.4095 201.993Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5459 177.535C16.5169 156.057 16.0233 128.047 15.2209 112.027C13.0252 138.294 13.054 156.831 14.5459 177.535Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.55611 138.821C7.60634 144.243 8.46786 142.247 8.27369 149.784C7.85617 150.268 7.26299 149.709 7.19238 152.45C7.49118 152.644 7.78998 152.837 7.62713 155.228L8.63783 155.303C8.46259 150.313 9.65906 139.246 8.55611 138.821Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7506 305.699C11.5128 311.001 12.3213 311.061 12.5495 313.996C12.2463 313.973 11.8857 316.178 12.4789 316.736C12.6329 314.688 12.967 313.512 13.5602 314.07C13.6308 311.33 13.7014 308.589 13.772 305.848C12.3526 305.915 12.8805 301.149 11.7506 305.699Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.77831 217.091C2.56293 217.59 2.33871 218.431 2.0002 219.779C2.32547 218.945 2.54969 218.104 2.77831 217.091Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.77831 100.656C2.56293 101.155 2.33871 101.996 2.0002 103.344C2.32547 102.51 2.54969 101.669 2.77831 100.656Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4281 225.747C9.09715 215.499 8.15705 212.684 8.48318 203.955C6.11443 205.496 4.44394 211.379 2.77344 217.262C4.92723 212.273 5.77295 234.475 6.47289 223.028C6.08184 222.484 5.46218 222.953 5.53279 220.212C5.71329 217.137 6.24953 215.975 6.6847 214.806C7.8799 215.581 7.58025 223.282 8.4281 225.747Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4281 109.312C9.09715 99.0644 8.15705 96.2489 8.48318 87.5205C6.11443 89.0614 4.44394 94.9445 2.77344 100.827C4.92723 95.8383 5.77295 118.04 6.47289 106.593C6.08184 106.049 5.46218 106.518 5.53279 103.778C5.71329 100.702 6.24953 99.5401 6.6847 98.371C7.8799 99.1459 7.58025 106.847 8.4281 109.312Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.04873 201.177C8.22524 194.326 7.66425 180.726 8.16603 173.041C8.04731 173.718 7.93739 174.054 7.73966 173.867C7.99518 167.88 7.56044 165.102 6.43542 165.533C6.29863 170.843 6.29824 174.79 6.2144 178.045C6.16144 180.1 6.11288 181.985 6.16982 183.705C6.07274 187.473 5.8834 190.892 5.15783 195.472C6.01009 197.766 6.85795 200.231 8.04873 201.177Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.04873 84.7426C8.22524 77.8909 7.66425 64.2916 8.16603 56.6059C8.04731 57.2836 7.93739 57.6187 7.73966 57.4324C7.99518 51.4447 7.56044 48.6666 6.43542 49.0982C6.29863 54.4083 6.29824 58.3555 6.2144 61.61C6.16144 63.6655 6.11288 65.5497 6.16982 67.2701C6.07274 71.0385 5.8834 74.4569 5.15783 79.0369C6.01009 81.331 6.85795 83.7964 8.04873 84.7426Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.65061 425.528C10.1908 405.048 10.1678 374.498 10.6849 346.563C8.7337 347.62 8.51178 368.026 8.39662 376.427C6.97723 376.493 7.50507 371.727 6.37522 376.277C7.19931 395.388 5.57607 411.228 6.5586 428.119C8.00048 423.249 6.89796 418.877 7.92233 414.491C7.89101 419.637 8.09273 423.599 8.65061 425.528Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9875 100.952C14.5895 101.168 14.6067 104.43 15.4329 103.805C18.0885 91.13 16.0568 63.864 16.4014 46.5561C12.7881 57.1007 16.0154 81.1944 13.9875 100.952Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6981 30.1265C14.5264 32.8597 14.5966 34.0662 14.6756 34.9302C14.6535 35.7866 14.6226 36.9857 14.5917 38.1847C14.9784 38.8998 15.6024 38.2595 15.5318 41.0002C15.0221 41.1341 15.0393 44.3961 15.9666 43.7782C15.7521 36.3828 17.1185 38.3717 17.2597 32.8904C17.0095 30.8124 16.324 29.9036 15.8099 30.2088L15.8143 30.0375L15.7088 30.2013C15.3968 30.5215 15.177 31.1917 14.9439 32.3758C14.8473 32.197 14.7595 31.6757 14.6981 30.1265Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.38121 136.772C6.72855 135.082 7.26559 126.026 6.93633 123.084C6.82159 127.538 5.92881 134.679 6.38121 136.772Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94069 -1.87726C8.19789 -0.559274 8.10789 18.6553 8.06376 20.3682C8.56996 12.5112 8.67193 4.62435 8.94069 -1.87726Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1048 26.6267C16.6856 19.8049 16.8801 8.32091 17.1582 -2.47046C16.6211 6.58556 14.5141 25.4793 16.1048 26.6267Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4978 986.928C16.8288 974.081 17.2652 961.071 15.754 956.84C15.6605 968.332 14.182 986.414 16.4978 986.928Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.21796 934.413C8.78214 936.588 7.9992 943.395 9.02756 942.785C8.71993 942.933 8.41231 943.082 8.4516 945.488C10.3057 948.199 9.22656 931.129 10.3869 929.327C9.53062 923.257 7.68886 927.926 7.21796 934.413Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8207 893.811L14.3367 893.923C14.1936 875.892 15.8001 852.843 14.1533 842.081C12.1302 857.72 13.1609 876.674 12.8207 893.811Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4095 811.993C14.117 812.045 14.7234 812.09 15.4309 812.142C15.7305 804.441 14.1924 805.186 13.6919 801.03C13.5992 804.627 13.5021 808.395 13.4095 811.993Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5459 787.535C16.5169 766.057 16.0233 738.047 15.2209 722.027C13.0252 748.294 13.054 766.831 14.5459 787.535Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.55611 748.821C7.60634 754.243 8.46786 752.247 8.27369 759.784C7.85617 760.268 7.26299 759.709 7.19238 762.45C7.49118 762.644 7.78998 762.837 7.62713 765.228L8.63783 765.303C8.46259 760.313 9.65906 749.246 8.55611 748.821Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7506 915.699C11.5128 921.001 12.3213 921.061 12.5495 923.996C12.2463 923.973 11.8857 926.177 12.4789 926.736C12.6329 924.688 12.967 923.512 13.5602 924.07C13.6308 921.33 13.7014 918.589 13.772 915.848C12.3526 915.915 12.8805 911.149 11.7506 915.699Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.77831 827.091C2.56293 827.59 2.33871 828.431 2.0002 829.779C2.32547 828.945 2.54969 828.104 2.77831 827.091Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4281 835.747C9.09715 825.499 8.15705 822.684 8.48318 813.955C6.11443 815.496 4.44394 821.379 2.77344 827.262C4.92723 822.273 5.77295 844.475 6.47289 833.028C6.08184 832.484 5.46218 832.953 5.53279 830.212C5.71329 827.137 6.24953 825.975 6.6847 824.806C7.8799 825.581 7.58025 833.282 8.4281 835.747Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.04873 811.178C8.22524 804.326 7.66425 790.727 8.16603 783.041C8.04731 783.719 7.93739 784.054 7.73966 783.867C7.99518 777.88 7.56044 775.102 6.43542 775.533C6.29863 780.843 6.29824 784.79 6.2144 788.045C6.16144 790.1 6.11288 791.985 6.16982 793.705C6.07274 797.473 5.8834 800.892 5.15783 805.472C6.01009 807.766 6.85795 810.231 8.04873 811.178Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.65061 1035.53C9.19085 1015.05 9.16777 984.498 9.68492 956.563C7.7337 957.62 7.51178 978.026 7.39662 986.427C5.97723 986.493 6.50507 981.727 5.37522 986.277C6.19931 1005.39 4.57607 1021.23 5.5586 1038.12C7.00048 1033.25 5.89796 1028.88 6.92233 1024.49C6.89101 1029.64 7.09273 1033.6 7.65061 1035.53Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9875 710.952C14.5895 711.168 14.6067 714.43 15.4329 713.805C18.0885 701.13 16.0568 673.864 16.4014 656.556C12.7881 667.101 16.0154 691.194 13.9875 710.952Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6981 640.127C14.5264 642.86 14.5966 644.066 14.6756 644.93C14.6535 645.787 14.6226 646.986 14.5917 648.185C14.9784 648.9 15.6024 648.26 15.5318 651C15.0221 651.134 15.0393 654.396 15.9666 653.778C15.7521 646.383 17.1185 648.372 17.2597 642.89C17.0095 640.812 16.324 639.904 15.8099 640.209L15.8143 640.038L15.7088 640.201C15.3968 640.521 15.177 641.192 14.9439 642.376C14.8473 642.197 14.7595 641.676 14.6981 640.127Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.38121 746.772C6.72855 745.082 7.26559 736.026 6.93633 733.084C6.82159 737.538 5.92881 744.679 6.38121 746.772Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6987 520.213C11.3373 530.311 11.008 527.37 10.5375 529.909C10.8668 532.851 10.726 534.385 11.4075 531.518C11.3465 526.022 12.103 520.243 11.6987 520.213Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9402 608.123C9.19741 609.441 9.1074 628.655 9.06327 630.368C9.56947 622.511 9.67144 614.624 9.9402 608.123Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1048 636.627C16.6856 629.805 16.8801 618.321 17.1582 607.53C16.6211 616.586 14.5141 635.479 16.1048 636.627Z",
    fill: "#17181D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1103_28843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 964,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberDetailInk);
export default __webpack_public_path__ + "static/media/member-detail-ink.126fecaeca5bbbba970268c0e1bcd7a8.svg";
export { ForwardRef as ReactComponent };